import { getSuperAdmin } from "../../api/Helper";
import { useEffect, useState } from "react";
import { getOrganizations } from "../../api/Services";
import HomeDashboard from "./components/HomeDashboard";

const Home = () => {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [organizationsQuantity, setOrganizationsQuantity] = useState(0);

  useEffect(() => {
    const validateSuperAdmin = async () => {
      const isUserSuperAdmin = await getSuperAdmin();
      const organizations = await getOrganizations();
      //- admin org
      setOrganizationsQuantity(organizations.length - 1);
      setIsSuperAdmin(isUserSuperAdmin);
    };

    validateSuperAdmin();
  }, []);

  return (
    <HomeDashboard 
      isSuperAdmin={isSuperAdmin}
      organizationsQuantity={organizationsQuantity}
    />
  );
};

export default Home;
